import type { SkillTypes } from "@memorang/types";
import { useCallback } from "react";
import PassageBanner from "./PassageBanner";

type MobilePassageSheetRenderProps = {
	title: string;
	openCta: string;
	skill: SkillTypes;
	stimulusCaption?: string;
	onOpenPassage?: () => void;
};

export const useMobilePassageSheet = ({
	title,
	openCta,
	skill,
	stimulusCaption,
	onOpenPassage,
}: MobilePassageSheetRenderProps) => {
	const renderMobilePassageBanner = useCallback(
		(openBottomSheet: () => void) => (
			<PassageBanner
				title={title}
				openCta={openCta}
				skill={skill}
				stimulusCaption={stimulusCaption}
				onPress={onOpenPassage ?? openBottomSheet}
			/>
		),
		[title, openCta, skill, stimulusCaption, onOpenPassage],
	);

	return { renderMobilePassageBanner };
};
